import { render, staticRenderFns } from "./InputSample.vue?vue&type=template&id=2a2234ac&scoped=true&lang=pug&"
import script from "./InputSample.vue?vue&type=script&lang=ts&"
export * from "./InputSample.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2234ac",
  null
  
)

export default component.exports